import { useState, useCallback } from 'react'

export const useClipboard = () => {
  const [copied, setCopied] = useState(false)

  const copyToClipboard = useCallback((text: string) => {
    // Create a textarea element to hold the text to be copied
    const textarea = document?.createElement('textarea')
    textarea.value = text

    // Append the textarea to the document
    document?.body.appendChild(textarea)

    // Select the text in the textarea
    textarea.select()
    textarea.setSelectionRange(0, textarea.value.length)

    // Attempt to copy the selected text
    document?.execCommand('copy')

    // Remove the textarea from the document
    document?.body?.removeChild(textarea)

    // Set the copied state to true
    setCopied(true)

    // Reset the copied state after a short delay
    setTimeout(() => {
      setCopied(false)
    }, 1500) // Adjust the delay as needed
  }, [])

  return { copied, copyToClipboard }
}
